import { makeRESTApiRequests } from "../helpers/api";
import { ENDPOINTS } from "../helpers/constants";

export const userServices = {
  getUserStats: async (reqBody) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_USER_STATS,
      method: "POST",
      requestBody: reqBody,
    });

    return { response, error };
  },
};
